<template>
  <IntroAtc
    v-if="variant === 'atc'"
    :close-wording
    :image
    :price
    :price-without-trade-in
    :product-title
    @close="emit('close')"
    @next-step="emit('next-step')"
  />
  <IntroPlp v-else @close="emit('close')" @next-step="emit('next-step')" />
</template>

<script lang="ts" setup>
import type { Price } from '@backmarket/http-api/src/api-models/Price'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'

import IntroAtc from './IntroAddToCart.vue'
import IntroPlp from './IntroProductListing.vue'

interface IntroProps {
  price?: Price
  priceWithoutTradeIn?: Price
  closeWording: string
  variant?: 'atc' | 'plp'
  image?: GetProductResponse['images'][number]
  productTitle?: string
}

defineProps<IntroProps>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'next-step'): void
}>()
</script>
